// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"56":"c60bed35","57":"bdc1c6d5","124":"7834ba17","353":"7cc4e601","449":"e9d2a7d9","453":"67a77d47","660":"dd8e7987","697":"0ce19d5a","712":"e3d410d8","819":"5dc36fb9"}[chunkId] + ".chunk.js";
};